import { render, staticRenderFns } from "./SelectedTemplateProperties.vue?vue&type=template&id=ac904866&scoped=true"
import script from "./SelectedTemplateProperties.vue?vue&type=script&lang=js"
export * from "./SelectedTemplateProperties.vue?vue&type=script&lang=js"
import style0 from "./SelectedTemplateProperties.vue?vue&type=style&index=0&id=ac904866&prod&lang=scss&scoped=true"
import style1 from "./SelectedTemplateProperties.vue?vue&type=style&index=1&id=ac904866&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac904866",
  null
  
)

export default component.exports